<nav class="nav">
  <a routerLink="/" class="brand">ReconcileX</a>

  <div class="links">
    @if (!isAuthenticated) {
      <a routerLink="/plans">Plans</a>
      <a routerLink="/register">{{ t('register.submit') }}</a>
      <a routerLink="/login">Login</a>
    }

    @if (isAuthenticated) {
      <a routerLink="/app">Dashboard</a>
      <a routerLink="/app/upload">Upload statement</a>
      <a routerLink="/app/statements">Statements</a>
      <span class="user-chip">{{ currentUser?.email }}</span>
      <button type="button" class="logout-btn" (click)="logout()">Logout</button>
    }

    <button type="button" (click)="toggleLang()">{{ langLabel }}</button>
  </div>
</nav>
